<template>
    <div class="property-search-form-wrapper">
        <div v-html="title"></div>
        <form novalidate @submit.stop.prevent="showBuildingView">
            <slot name="inline-title"/>
            <div>
                <div class="block">
                    <label for="communities_field">Communities</label>
                    <el-select id="communities_field"
                               v-model="input.title"
                               placeholder="Communities"
                               class="form-field"
                               @change="toggleView"
                    >
                        <el-option
                                v-for="(type, index) in properties"
                                :key="index"
                                :label="type.label"
                                :value="type.value"
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="block">
                    <label for="bedrooms_field">Bedrooms</label>
                    <el-select id="bedrooms_field"
                        v-model="input.beds"
                               placeholder="Bedrooms"
                               class="form-field"
                    >
                        <el-option
                                v-for="type in bedrooms"
                                :key="type.value"
                                :label="type.label"
                                :value="type.value"
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="block">
                    <label for="bathrooms_field">Bathrooms</label>
                    <el-select id="bathrooms_field"
                               v-model="input.baths"
                               placeholder="Bathrooms"
                               class="form-field"
                    >
                        <el-option
                                v-for="type in bathrooms"
                                :key="type.value"
                                :label="type.label"
                                :value="type.value"
                        >
                        </el-option>
                    </el-select>
                </div>

                <div class="block">
                    <label for="state_field">State</label>
                    <el-select id="state_field"
                               v-model="input.state"
                               placeholder="State"
                               class="form-field"
                               @change="updateCities"
                    >
                        <el-option
                                v-for="item in postsStates"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </div>

                <div class="block">
                    <label for="city_field">City</label>
                    <el-select id="city_field"
                               v-model="input.city"
                               placeholder="City"
                    >
                        <el-option
                                v-for="(city, index) in cities"
                                :key="index"
                                :label="city"
                                :value="city"
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="block">
                    <label for="zipcode_field">Zip Code</label>
                    <el-input id="zipcode_field"
                              v-model="input.zip"
                              :minlength="4"
                              :maxlength="5"
                              type="number"
                              placeholder="Zip Code" />
                </div>
                <div class="block">
                    <label for="amenities_field">Amenities</label>
                    <el-select id="amenities_field"
                            v-model="input.amenities"
                            multiple
                            collapse-tags
                            placeholder="Features">
                        <el-option
                                v-for="(item, index) in amenities"
                                :key="index"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <button @click="showBuildingView" class="link-cta inline-block-i">
                View Results <font-awesome-icon class="building" :icon="icons.building"/>
            </button>
        </form>
    </div>
</template>
<script>
    import states from './states';
    import CustomInputMixin from '../../mixins/customInput.mixin.js';
    import Amenities from './AmenitiesCustomField';
    import currencyFormatter from 'currency-formatter';
    import _map from 'lodash/map';
    import _uniq from 'lodash/uniq';
    import _uniqBy from 'lodash/uniqBy';
    import _contains from 'lodash/includes';
    import _reject from 'lodash/reject';
    import _camelCase from 'lodash/camelCase';
    import {faBell} from '@fortawesome/pro-regular-svg-icons/fabell'
    import {faBuilding} from '@fortawesome/pro-light-svg-icons/faBuilding'

    export default {
        name: 'AptSearchTool',
        components: {Amenities},
        mixins: [CustomInputMixin],
        props: {
            locations: {
                type: Array,
                default: []
            },
            hasSubmit: {
                default: true,
                types: Boolean
            }
        },
        data() {
            return {
                input: {
                    title: '',
                    beds: '',
                    baths: '',
                    city: '',
                    date: '',
                    state: '',
                    zip: '',
                    price: [0, 9999],
                    features: [],
                    amenities: [],
                },
                states,
                enableWatcher: true,
                propertyName: '*'
            }
        },
        computed: {
            title() {
                return 'Search Options';
            },
            icons() {
                return {
                    bell: faBell,
                    building: faBuilding
                }
            },
            bathrooms() {

                const filters = wp && wp.filters && wp.filters.bathrooms;

                if (!filters)
                    return [];

                return _map(filters, (filter) => {
                    return {
                        value: +filter.value,
                        label: filter.label
                    }
                })
            },
            bedrooms() {
                const filters = wp && wp.filters && wp.filters.bedrooms;

                if (!filters)
                    return [];

                return _map(filters, (filter) => {
                    return {
                        value: +filter.value,
                        label: filter.label
                    }
                })
            },
            amenitiesSettings(){
                return wp.amenities;
            },
            amenities() {
                return _map(this.amenitiesSettings, item => {
                    return {
                        value: item.value,
                        label: item.label
                    }
                });
            },
            properties(){
                let properties = _map(this.locations, loc => {
                    return {
                        label: loc.title.rendered.replaceAll('&#038;', '&'),
                        value: loc.title.rendered.replaceAll('&#038;', '&') || '',
                    }
                });
                properties.unshift({value: '*', label: 'Communities'});
                return properties;
            },
            postsStates() {
                // Get all posts states
                let states = _uniq(
                    _map(this.locations, (post) => {
                        return post.acf.state;
                    }), 'label');
                let mappedStates = _uniqBy(states, 'value');
                mappedStates.unshift({value: '*', label: 'All'});
                return mappedStates;
            },
            cities() {
                // Get all posts cities
                let mappedCities = _uniq(
                    _map(
                        _reject(this.locations, (post) => {
                            return !_contains(['', 'All', post.acf.state.value], this.input.state);
                        }), (post) => {
                            return post.acf.city
                        }
                    )
                );
                mappedCities.unshift('All');
                return mappedCities;
            },
            priceMin() {
                return `${this.formatCurrencyAmount(this.input.price[0])}`;
            },
            priceMax() {
                return `${this.formatCurrencyAmount(this.input.price[1])}`;
            }
        },
        methods: {
            goToProperty(val) {
                this.openInNewTab(val);
            },
            openInNewTab(url) {
                if (url === '*') return;
                const win = window.open(url, '_blank');
                win.focus();
            },
            updateCities(){
                this.input.city = 'All';
            },
            formatCurrencyAmount(amount) {
                return currencyFormatter.format(amount, {
                    code: 'USD',
                    symbol: '$',
                    thousandsSeparator: ',',
                    decimalSeparator: '.',
                    symbolOnLeft: true,
                    precision: 0,
                    spaceBetweenAmountAndSymbol: false,
                    decimalDigits: 0,
                });
            },
            formatTooltip(val) {
                return this.formatCurrencyAmount(val);
            },
            showBuildingView() {
                this.$emit('showBuildingView')
            },
            toggleView() {
                this.$emit('toggleView', 'building');
            }
        }
    }
</script>
<style lang="scss" type="text/scss">
    .property-search-form-wrapper {
        margin: 0 auto;
        max-width: 420px;
        color: #fff;
        padding: 40px 40px 30px;
        font-size: $font-family-size;
        font-family: $font-family-body;

        label.lb-price-range {
            padding-left: 16px;
            font-size: $font-family-size;
        }
        .el-slider__runway {
            height: 3px;
        }
        .el-slider__bar {
            background-color: $theme-green;
            height: 3px;
        }
        .el-slider__button {
            border: 0;
            height: 12px;
            width: 12px;
            transform: translateY(-1px);
        }
        .el-slider__button {
            width: 14px;
            height: 14px;
        }
        .link-cta {
            background-image: linear-gradient(to bottom, $theme-green 0%, $theme-green 50%, $theme-green 100%);
            font-family: $font-family-body;
            margin-top: 25px;
            width: 100%;
            color: #fff;
            box-shadow: none;
            border: 0;
            border-radius: 0;
            height: 40px;
            cursor: pointer;
            transition: all .3s ease-in-out;
            font-size: 12px;
            &:hover {
                opacity: .8;
            }

            .building {
                margin-left: 10px;
            }

            @media (min-width: 1200px) {
                display: none;
            }
        }
        hr {
            border-color: #a1a1a1;
            margin: 30px 0;
        }
        label.features {
            margin-top: 30px;
            padding-left: 23px;
            display: block;
            margin-bottom: 10px;
            font-size: $font-family-size;
        }
        .el-checkbox-group {
            display: flex;
            flex-wrap: wrap;
            .el-checkbox {
                margin: 0 0 10px 0!important;
                width: 50%;
                text-overflow: ellipsis;
                overflow: hidden;

                .el-checkbox__label {
                    color: #fff;
                }
            }
        }

        .el-checkbox__input.is-checked .el-checkbox__inner,
        .el-checkbox__input.is-indeterminate .el-checkbox__inner {
            background-color: $theme-green;
            border-color: $theme-green;
        }
        .el-checkbox__inner {
            border-radius: 50%;
        }
        form {
            font-size: $font-family-size;
            .block {
                margin-top: 15px;

                label {
                    display: none!important;
                }
            }

            input {
                &::-webkit-input-placeholder {
                    opacity: 1;
                    color: #fff !important;
                }
                &:-moz-placeholder { /* Firefox 18- */
                    opacity: 1;
                    color: #fff !important;
                }
                &::-moz-placeholder { /* Firefox 19+ */
                    opacity: 1;
                    color: #fff !important;
                }
                &:-ms-input-placeholder {
                    opacity: 1;
                    color: #fff !important;
                }
                &::placeholder {
                    opacity: 1;
                    color: #fff !important;
                }
            }

            input[type="text"],
            input[type="number"] {
                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;
            }

            input[type='text']:focus,
            input[type='number']:focus,
            textarea:focus {
                font-size: 13px;
                &::-webkit-input-placeholder {
                    opacity: 1;
                    color: #fff !important;
                }
                &:-moz-placeholder { /* Firefox 18- */
                    opacity: 1;
                    color: #fff !important;
                }
                &::-moz-placeholder { /* Firefox 19+ */
                    opacity: 1;
                    color: #fff !important;
                }
                &:-ms-input-placeholder {
                    opacity: 1;
                    color: #fff !important;
                }
                &::placeholder {
                    opacity: 1;
                    color: #fff !important;
                }
            }

            /* disable auto-zoom on iphone input field focus */
            @media screen and (-webkit-min-device-pixel-ratio:0) {

                select:focus,
                textarea:focus,
                input:focus {
                    font-size: 13px;
                }
            }

            @media (max-width: 767px) {

                // prevents phone from zooming in
                input[type="text"],
                input[type="number"] {
                    font-size: 13px;
                }
            }
        }
        .el-slider__button {
            top: -5%;
        }
        .el-input__inner {
            background: transparent;
            border: 1px solid #fff;
            color: #fff;
            border-radius: 0;
            font-size: $font-family-size;
            font-family: $font-family-body;
            margin: 0;
        }
        .el-checkbox__label {
            font-size: $font-family-size;
            font-family: $font-family-body;
        }
        .el-input, .el-select {
            width: 100%;
            max-width: 100%;
        }
    }

    .page {
        /*element UI custom*/
        .el-select-dropdown__item, .el-picker-panel {
            font-family: $font-family-body;
            font-size: 12px;
        }
        .el-date-table td.current:not(.disabled) span {
            background-color: $theme-green;
        }
        .el-date-table td.available:hover {
            color: $theme-green;
        }
        .el-date-table td.today span {
            color: $theme-green;
        }
        .el-date-picker__header-label.active,
        .el-date-picker__header-label:hover {
            color: $theme-green;
        }
        .el-picker-panel__icon-btn:hover {
            color: $theme-green;
        }
        .el-input.is-active .el-input__inner,
        .el-select .el-input__inner:focus,
        .el-select .el-input.is-focus .el-input__inner {
            border-color: $theme-green;
        }
        .el-select-dropdown__item.selected {
            color: $theme-green;
        }
    }
</style>
